module.exports = __webpack_public_path__ + "static/media/CompanySetup.e133be2f.png";